// eslint-disable-next-line import/no-unresolved
const baseUtils = require('./baseUtils');

// EXTENDED BASE METHODS

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    return $el && $($el).parents('.product-structure').length
        ? $($el).closest('.product-detail .product-structure').find('.quantity')
        : $($el).parents('.product-tile').find('.quantity').eq(1);
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
baseUtils.getQuantitySelected = $el => getQuantitySelector($el).val();

baseUtils.disabledButtonCartGrid = (node) => {
    const $node = $(node);

    $node
        .find('.select-attr-error')
        .remove();
    let disable = true;
    $node
        .find('.product-detail:not(.product-detail-set) .attribute')
        // eslint-disable-next-line func-names
        .each(function () {
            if ($(this).find('select').length) {
                if (
                    $(this)
                        .find("select[class*='select-']")
                        .children('option:selected')
                        .attr('data-attr-value') === undefined
                ) {
                    $(this).append(
                        `<span class="select-attr-error">${$(this).data('error')}</span>`,
                    );
                    disable = false;
                }
            } else if (!$(this).find('.selected').length) {
                $(this).append(`<span class="select-attr-error">${$(this).data('error')}</span>`);
                disable = false;
            }
        });
    return disable;
};

// GRID LOGIC

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValueGrid($el) {
    let pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el)
            .closest('.modal-content')
            .find('.product-quickview')
            .data('pid');
    } else if ($($el).find('.product-set-detail').length || $($el).find('.product-set').length) {
        pid = $($el)
            .closest('.product-detail')
            .find('.product-id')
            .text();
    } else {
        pid = $($el).data('pid');
    }

    return pid;
}

// Event rewrite to control the add to cart button

const addToCartGrid = (node) => {
    $(node).off('click', '.add-to-cartGrid, .add-to-cart-globalGrid, .add-to-cart-grid-marshall').on('click', '.add-to-cartGrid, .add-to-cart-globalGrid, .add-to-cart-grid-marshall', (e) => {
        const currentTarget = $(e.currentTarget);
        if (currentTarget.hasClass('outofstock')) {
            // eslint-disable-next-line global-require
            const outOfStock = require('../product/outOfStock');
            const pid = currentTarget.data('pid');
            outOfStock.showOutofStockGrid(pid);
            return;
        }
        const component = currentTarget.closest('.product-tile');
        const colorComponents = component.find('.gridSwatch');
        if (colorComponents.length && component.find('.container-swatches .selected').length === 0) {
            component.find('.container-swatches .select-swatch-message').fadeIn(() => {
                $('.select-swatch-message').delay(2000).fadeOut();
            });
            return;
        }

        const relatedParent = $(e.target).parents('.product-tile').parent();
        const enabled = baseUtils.disabledButtonCartGrid(relatedParent);

        if (enabled) {
            const addToCartUrl = baseUtils.methods.getAddToCartUrl();
            const pid = getPidValueGrid(currentTarget);
            let pidsObj;
            let setPids;

            $('body').trigger('product:beforeAddToCart', e.currentTarget);

            if ($('.set-items').length && currentTarget.hasClass('add-to-cart-globalGrid')) {
                setPids = [];

                $('.product-detail:not(.product-detail-set)').each(() => {
                    if (!currentTarget.hasClass('product-set-detail')) {
                        setPids.push({
                            pid: currentTarget.parents('.product-tile')
                                .find('.product-id')
                                .text(),
                            qty: currentTarget.parents('.product-tile')
                                .find('.quantity-select')
                                .val(),
                            options: baseUtils.methods.getOptions(currentTarget),
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            let $productContainer = currentTarget.closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = currentTarget
                    .parents('.product-tile')
                    .find('.product-detail');
            }

            const form = {
                pid,
                pidsObj,
                childProducts: baseUtils.methods.getChildProducts(),
                quantity: 1,
            };

            if (!$('.bundle-item').length) {
                form.options = baseUtils.methods.getOptions($productContainer);
            }

            currentTarget.trigger('updateAddToCartFormData', form);

            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success(data) {
                        const swatchTooltip = $('.select-swatch-message');
                        baseUtils.methods.handlePostCartAdd(data);
                        if ($('#quickViewModal').length) {
                            $('body').trigger('product:afterAddToCart', data);
                        }
                        if (swatchTooltip.length) {
                            swatchTooltip.fadeOut();
                        }
                        $.spinner().stop();
                    },
                    error() {
                        $.spinner().stop();
                    },
                });
            }
        }
    });
};

function checkAddToCartButton(productTile) {
    const productTileClone = productTile.closest('.product-tile');
    let disEvent = true;

    $('.select-color-error').remove();

    if (disEvent) {
        // Check Swatch
        const existSwatch = productTileClone.find('.gridSwatch');
        if (existSwatch.length) {
            disEvent = productTileClone.find('.gridSwatch .selected').length !== 0;

            if (disEvent) {
            // Check rest of variants
                productTileClone.find('.swatch').each((index, node) => {
                    const variationType = $(node).data('attr');
                    if (disEvent && variationType && variationType !== 'color') {
                        const content = $(node).find('.attributeLink.attributeSelected');
                        disEvent = content.length !== 0;
                    }
                });
            }
        }

        const $AddToCartbutton = productTileClone.find('.cart-and-ipay .add-to-cart-grid-marshall');
        if (!disEvent) {
            if (!$AddToCartbutton.is(':disabled')) {
                $AddToCartbutton.attr('disabled', 'disabled');
                $AddToCartbutton.addClass('disabled');
            }
        } else {
            $AddToCartbutton.removeAttr('disabled');
            $AddToCartbutton.removeClass('disabled');
        }
    }
}


function gridDataLayerUpdateAfterHandleVariants(response, $productContainer) {
    const productTileSku = $productContainer.parents('.product').find('.gtmSkuVariation');
    const productTileVariations = $productContainer.parents('.product').find('.gtmProdVariations');
    const { variationAttributes } = response.product;

    // update datalayer of input hidden (Ex:used for add to card actions)
    if (variationAttributes) {
        productTileVariations.attr('data-pinfo', JSON.stringify(variationAttributes));
    }

    if (productTileSku.length) {
        productTileSku.data('pinfo', response.product.id);
    }
}

function updateAttributeStateClass(attrValue, itemVariation,
    isOutOfStockProdNotAvailable, stockValue, siteLastItemsConfig) {
    const siteAvailableOutOfstock = $('#siteAvailableOutOfstock').val();

    // will be 'unselectable':
    // with siteAvailableOutOfstock: false -> and it's not selectable and out of stock
    // and is not the first variation attribute type,
    // with siteAvailableOutOfstock: false -> and have no stock,
    // with siteAvailableOutOfstock: true -> and it's not selectable and out of stock
    if ((!attrValue.selectable && !attrValue.isoutOfstock && itemVariation.parents('.attr-swatch-list').index() !== 0)
    || isOutOfStockProdNotAvailable) {
        itemVariation.addClass('unselectable');
    // is selectable and have no stock
    } else if (attrValue.selectable && attrValue.isoutOfstock && siteAvailableOutOfstock === 'true') {
        itemVariation.addClass('outofstock icon-email-line');
    } else if (stockValue !== 'undefined'
                && !attrValue.isoutOfstock
                && stockValue <= siteLastItemsConfig) {
        itemVariation.addClass('lastItems');

        if (!itemVariation.find('.message-last-items').length) {
            const lastItemsMessageTooltip = $('#lastItemsMessageTooltip').val();
            const lastItemsDiv = `<div class="message-last-items tooltip">${lastItemsMessageTooltip}</div><span class="circle-red"></span>`;

            itemVariation.append(lastItemsDiv);
        }
    }
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValuesGrid(attr, $productContainer) {
    const $attr = `[data-attr="${attr.id}"]`;
    const $defaultOption = $productContainer.find(`${$attr} .select-${attr.id} option:first`);
    const siteAvailableOutOfstock = $('#siteAvailableOutOfstock').val();
    const siteLastItemsConfig = parseInt($('#siteLastItemsConfig').val(), 10);

    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach((attrValue) => {
        const itemVariation = $productContainer.parents('.product').find(
            `${$attr} [data-attr-value="${attrValue.value}"]`,
        );
        const isOutOfStockProdNotAvailable = siteAvailableOutOfstock === 'false' && attrValue.isoutOfstock;
        const stockValue = attrValue.stock !== null ? attrValue.stock[itemVariation.data('attr-value')] : 'undefined';

        itemVariation.attr('value', attrValue.url).removeAttr('disabled');

        itemVariation.removeClass('outofstock icon-email-line d-none selected unselectable lastItems');

        updateAttributeStateClass(attrValue, itemVariation,
            isOutOfStockProdNotAvailable, stockValue, siteLastItemsConfig);
    });
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processSwatchValuesGrid(attr, $productContainer) {
    const siteAvailableOutOfstock = $('#siteAvailableOutOfstock').val();
    const siteLastItemsConfig = parseInt($('#siteLastItemsConfig').val(), 10);

    attr.values.forEach((attrValue) => {
        const tileProduct = $productContainer.parents('.product');
        const itemVariation = tileProduct.find(
            `[data-attr-value="${attrValue.value}"]`,
        );
        const $swatchAnchor = itemVariation.parent();
        const isOutOfStockProdNotAvailable = siteAvailableOutOfstock === 'false' && attrValue.isoutOfstock;
        const stockValue = attrValue.stock !== null ? attrValue.stock[itemVariation.data('attr-value')] : 'undefined';

        $swatchAnchor.attr('data-url', attrValue.url);
        $swatchAnchor.attr('href', attrValue.url);

        // Update Tile URLs on color swatch
        const variationUrlNoParams = attrValue.variationUrl.toString().split('?');
        const $wishlistContainer = $productContainer.closest('.product').find('.wishlistTile');
        let wishlistURL;
        if ($wishlistContainer.length) {
            wishlistURL = $wishlistContainer.attr('href');
        }
        tileProduct.find('.pdp-link a, .image-container a :not(.wishlistTile)').attr('href', variationUrlNoParams[0]);
        if (wishlistURL) {
            $wishlistContainer.attr('href', wishlistURL);
        }

        if (itemVariation.parents('.attr-swatch-list').index() !== 0) {
        // Disable if not selectable
            itemVariation.removeClass('outofstock icon-email-line d-none selected lastItems unselectable');
        }
        if (attrValue.selected) {
            itemVariation.addClass('selected');
        } else {
            itemVariation.removeClass('selected');
        }

        itemVariation.addClass(attrValue.selectable ? 'selectable' : '');

        updateAttributeStateClass(attrValue, itemVariation,
            isOutOfStockProdNotAvailable, stockValue, siteLastItemsConfig);

        if (!$('#quickViewModal').length) {
            const value = itemVariation.data('attr-value');
            const elemt = $productContainer.parent().closest('.product-tile');
            if (attrValue.selectable) {
                elemt.find(`a[data-attr-value='${value}']`).addClass('gridSwatch');
                elemt.find(`a[data-attr-value='${value}']`).data('attr-value', value);
            }
        }
    });
}

/**
 * Res the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAttrs(attrs, $productContainer) {
    const swatchablesToCheck = $productContainer
        .closest('.tile-body').find('a.swatchable').parents('.swatch');

    // Array: Get the current swhatchables attr of some product container. ['color']
    const attrsWithSwatches = baseUtils.methods.getSwhatchables(swatchablesToCheck);

    attrs.forEach((attr) => {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValuesGrid(attr, $productContainer);
        } else {
            processNonSwatchValuesGrid(attr, $productContainer);
        }
    });
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponseGrid(response, $productContainer) {
    const secondaryImageAvailable = $('.search-results').attr('data-secondaryimage');
    const isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    const tailImageLink = $productContainer
        .parent()
        .closest('.product-tile')
        .find('.image-container > a')[0];
    let isVariant;

    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVariant = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVariant) {
            $productContainer.parent('.bonus-product-item').data('pid', response.product.id);

            $productContainer
                .parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        } else if (isVariant && response.dataLayer) {
            gridDataLayerUpdateAfterHandleVariants(response, $productContainer);
        }
    }

    if ($productContainer.find('span.selected').length > 0) {
        // Update primary images
        const primaryImageUrls = response.product.images;
        primaryImageUrls.large.forEach((imageUrl, idx) => {
            $productContainer
                .parent()
                .closest('.product-tile')
                .find('.image-container')
                .find('.primary-tile-image')
                .eq(idx)
                .attr('src', imageUrl.url)
                .data('src', imageUrl.url)
                .attr('srcset', `${imageUrl.url} 768w, ${imageUrl.url} 1920w`)
                .data('srcset', `${imageUrl.url} 768w, ${imageUrl.url} 1920w`);

            if (idx === 1 && secondaryImageAvailable !== 'false') {
                $productContainer
                    .parent()
                    .closest('.product-tile')
                    .find('.image-container')
                    .find('.secondary-tile-image')
                    .eq(0)
                    .attr('src', imageUrl.url)
                    .data('src', imageUrl.url)
                    .attr('srcset', `${imageUrl.url} 768w, ${imageUrl.url} 1920w`)
                    .data('srcset', `${imageUrl.url} 768w, ${imageUrl.url} 1920w`);
            }
            let urlNew = `${tailImageLink.href.split('pid=')[0]}`;
            if (urlNew.indexOf('?') > 0) {
                urlNew += `pid=${response.product.id}`;
            } else {
                urlNew += `?pid=${response.product.id}`;
            }
            tailImageLink.href = urlNew;
        });
    }

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        const $elemt = $productContainer.parent().closest('.product-tile');
        const $priceSelector = $elemt.find('.price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    if (isChoiceOfBonusProducts) {
        const $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product,
            $productContainer,
        });
    } else {
        const productNotAvailable = !response.product.readyToOrder || !response.product.available;
        const addToCartButton = $('button.add-to-cart-globalGrid', $productContainer);
        // Enable "Add to Cart" button if all required attributes have been selected
        addToCartButton.attr(
            'disabled',
            productNotAvailable,
        );

        if (productNotAvailable) {
            addToCartButton.addClass('disabled');
        } else {
            addToCartButton.removeClass('disabled');
        }
    }

    const { variationAttributes } = response.product;
    // Update attributes
    const $button = $productContainer.parents('.product').find('.add-to-cart-grid-marshall');
    $button.data('pid', response.product.id);
    if (variationAttributes) {
        if (variationAttributes.length > 1) {
            // eslint-disable-next-line no-use-before-define
            checkAddToCartButton($productContainer, '', '');
        } else {
            variationAttributes.forEach((attributes) => {
                attributes.values.forEach((attribute) => {
                    if (attribute.selected) {
                        if (attribute.isoutOfstock) {
                            $button.addClass('outofstock');
                            $button.text(attribute.buttonText);
                            $button.removeAttr('disabled');
                            $button.removeClass('disabled');
                            $button.data('pid', response.product.id);
                        } else {
                            $button.removeClass('outofstock');
                            $button.html(`<i class=" fa fa-shopping-bag"></i> ${attribute.buttonText}`);
                            if (attribute.isSelectable) {
                                $button.removeAttr('disabled');
                                $button.removeClass('disabled');
                            }
                            $button.data('pid', response.product.id);
                        }
                    }
                });
            });
        }
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect', {
            url: selectedValueUrl,
            container: $productContainer,
        });

        $.ajax({
            url: selectedValueUrl,
            type: 'GET',
            dataType: 'json',
            success(data) {
                handleVariantResponseGrid(data, $productContainer);

                $('body').trigger('product:afterAttributeSelect', {
                    data,
                    container: $productContainer,
                });
                if(!$('.add-to-cart-Tile.active')){
                    $.spinner().stop();
                }
            },
            error() {
                $.spinner().stop();
            },
        });
    }
}

module.exports = {
    ...baseUtils,
    addToCartGrid,
    getPidValueGrid,
    attributeSelect,
    checkAddToCartButton,
};
